import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
// import { setMenuActive } from "../../actions/menuAction";
import { openSettings } from "../../actions/settingActions";
import SettingPopup from "../SettingPopup";
import "./ProfileCard.css";

const ProfilePage = () => {
  const profileDropdown = useRef(null);
  const element = useRef(null);
  const [showHeader, setShowHeader] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);
  const [profileDropdownShow, setProfileDropdownShow] = useState(false);
  const [darkMode, setDarkMode] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const { mode } = useSelector((state) => state.mode);
  const { orders } = useSelector((state) => state.orderCreate);
  const { isSettingOpen } = useSelector((state) => state.setting);
  const teacherMode =
    mode === "teacher" || mode === "learning" || mode === "teaching";
  const showDropdown = (e) => {
    profileDropdown.current.classList.toggle("show");
    setProfileDropdownShow(true);
    setShowHeader(true);
    setShowSidebar(true);
  };

  const showSetting = (e) => {
    if (profileDropdown.current.classList.contains("show")) {
      profileDropdown.current.classList.remove("show");
    }
    if (e.target !== e.currentTarget) return;
    if (isSettingOpen) {
      dispatch(openSettings(false));
    } else {
      console.log("hai");
      dispatch(openSettings(true));
    }
  };

  const handleMovePage = (page) => {
    history.push(`/${page}`);
    profileDropdown.current.classList.remove("show");
  };

  useEffect(() => {
    window.onclick = (e) => {
      if (profileDropdownShow) {
        if (e.target.closest("#profile-dropdown") === null) {
          profileDropdown.current.classList.remove("show");
          setProfileDropdownShow(false);
        }
      }
    };

    const body = document.getElementsByTagName("body")[0];
    if (darkMode) {
      body.classList.add("dark-mode");
    } else {
      body.classList.remove("dark-mode");
    }
  }, [darkMode, showHeader, showSidebar, profileDropdownShow]);

  return (
    <>
      <div className={`profileCard header`} onClick={showDropdown}>
        <div className={`profileCard__profileLeft header`}>
          <div className="profileCard__profileImg">
            <img
              src="https://images.unsplash.com/photo-1554126807-6b10f6f6692a?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=870&q=80"
              alt="profilepicture"
              className="rounded"
            />
          </div>
          <div className={`profileCard__profileText header`}>
            <h3>Abraham Benjamin </h3>
            <div className="flex-row">
              {!teacherMode && (
                <img
                  src="https://gist.githubusercontent.com/faustabmnyh/62245f19337b13c5195999e7acbb525d/raw/81c387cc1659a4c95f2ddc59474f775cadb17dcd/glasses-emoji.svg"
                  alt="radiant"
                  className="profileCard__badge"
                />
              )}
              <p>{teacherMode ? "Teacher" : "Radiant"}</p>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`profileCard__dropdow flex-column  header`}
        ref={profileDropdown}
        id="profile-dropdown"
      >
        <div className="profileCard__dropdownHeader flex-row">
          <div className="profileCard__dropdownProfileImg flex-column">
            <img
              src="https://images.unsplash.com/photo-1554126807-6b10f6f6692a?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=870&q=80"
              alt="profilepicture"
              className="rounded profileCard__dropdownProfiePicture"
            />
            <div className="profileCard__dropdownProfileText flex-column">
              <h3>
                Abraham Benjamin{" "}
                {mode === "teacher" && (
                  <svg
                    viewBox="0 0 26 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.45898 13L11.7292 18.2708L22 8"
                      stroke="#077aff"
                      strokeWidth="3.54167"
                      strokeLinecap="round"
                    />
                  </svg>
                )}
              </h3>
              <div className="flex-row">
                {!teacherMode && (
                  <img
                    src="https://gist.githubusercontent.com/faustabmnyh/62245f19337b13c5195999e7acbb525d/raw/81c387cc1659a4c95f2ddc59474f775cadb17dcd/glasses-emoji.svg"
                    alt="radiant"
                    className="profileCard__badge"
                  />
                )}
                <p>{teacherMode ? "Teacher" : "Radiant"}</p>
              </div>
            </div>
          </div>
          <div className="profileCard__dropdowProfileDetails">
            <div className="profileCard__dropdowProfileDetail">
              <small>{teacherMode ? "Sessions" : "Projects"}</small>
              <p>0</p>
            </div>
            <div className="profileCard__dropdowProfileDetail">
              <small>Balance</small>
              <p>$0.00</p>
            </div>
            <div className="profileCard__dropdowProfileDetail status">
              <small>{teacherMode ? "Topic" : "My Plan"}</small>
              <p>{teacherMode ? "Science" : "Free"}</p>
            </div>
          </div>
        </div>
        <ul className="profileCard__dropdownMenu flex-column" ref={element}>
          {teacherMode && (
            <li className="profileCard__dropdownMenuItem flex-row withdrawal-option">
              <svg
                viewBox="0 0 512 512"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M104.044 221.204H91.8144C81.4235 221.204 73 212.78 73 202.389V52.8144C73 42.4235 81.4235 34 91.8144 34H419.186C429.577 34 438 42.4235 438 52.8144V202.389C438 212.78 429.576 221.204 419.186 221.204H418.245"
                  stroke="black"
                  strokeWidth="47.0361"
                  strokeLinecap="square"
                  strokeLinejoin="round"
                />
                <path
                  d="M157.809 81.0373C144.225 81.0373 133.213 92.0494 133.213 105.633L133.213 279.643V286.033L133.216 487.291C133.216 500.875 144.228 511.887 157.812 511.887L361.271 511.887C374.855 511.887 385.867 500.875 385.867 487.291L385.867 105.632C385.867 92.0483 374.855 81.0362 361.271 81.0363L157.809 81.0373ZM304.377 124.809C307.559 124.809 310.14 127.389 310.14 130.572C310.14 145.69 322.37 157.989 337.404 157.989C340.587 157.989 343.167 160.569 343.167 163.752L343.167 429.174C343.167 432.356 340.587 434.936 337.404 434.936C322.37 434.936 310.14 447.236 310.14 462.354C310.14 465.537 307.559 468.117 304.377 468.117L216.323 468.117C213.14 468.117 210.56 465.538 210.56 462.354C210.56 447.236 198.332 434.936 183.301 434.936C180.118 434.936 177.538 432.356 177.538 429.174L177.538 163.752C177.538 160.569 180.118 157.989 183.301 157.989C198.332 157.989 210.56 145.69 210.56 130.572C210.56 127.389 213.139 124.809 216.323 124.809L304.377 124.809Z"
                  fill="black"
                />
                <path
                  d="M231.045 297.71C231.045 313.274 243.638 325.936 259.116 325.936C274.591 325.936 287.179 313.274 287.179 297.71C287.179 282.147 274.591 269.482 259.116 269.482C243.638 269.482 231.045 282.145 231.045 297.71Z"
                  fill="black"
                />
                <path
                  d="M198.76 167.343C193.215 169.853 188.636 174.835 188.636 180.922L188.636 414.499C188.636 420.585 193.215 425.567 198.76 428.077C207.407 431.992 214.378 438.999 218.268 447.687C220.759 453.249 225.746 457.838 231.841 457.838L288.002 457.838C294.096 457.838 299.083 453.249 301.574 447.687C305.465 438.999 312.439 431.99 321.089 428.076C326.634 425.566 331.214 420.584 331.214 414.497L331.214 180.921C331.214 174.835 326.635 169.853 321.089 167.343C312.44 163.429 305.465 156.421 301.574 147.733C299.083 142.17 294.096 137.581 288.002 137.581L231.841 137.581C225.746 137.581 220.759 142.17 218.269 147.733C214.379 156.42 207.407 163.428 198.76 167.343ZM298.704 297.71C298.704 319.629 280.944 337.461 259.116 337.461C237.283 337.461 219.52 319.629 219.52 297.71C219.52 275.791 237.283 257.959 259.116 257.959C280.944 257.957 298.704 275.79 298.704 297.71Z"
                  fill="black"
                />
              </svg>
              Withdrawal
            </li>
          )}

          <li
            className="profileCard__dropdownMenuItem flex-row"
            onClick={() => handleMovePage("contact-support")}
          >
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.4 1.5195C6.62 1.8295 3 6.0095 3 10.8095V20.4995H9V12.4995H5V10.7895C5 6.9495 7.96 3.6095 11.79 3.4995C15.76 3.3895 19 6.5595 19 10.4995V12.4995H15V20.4995H19V21.4995H12V23.4995H21V10.4995C21 5.3295 16.64 1.1795 11.4 1.5195Z"
                fill="#11BB70"
              />
            </svg>
            Contact Support
          </li>

          {orders.length !== 0 && (
            <li
              className="profileCard__dropdownMenuItem flex-row"
              onClick={() => handleMovePage("track")}
            >
              <svg
                width="32"
                height="32"
                viewBox="0 0 240 240"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M213.675 97.1063L202.078 78.4406C199.553 74.3752 196.032 71.0217 191.849 68.6967C187.665 66.3722 182.958 65.1534 178.172 65.1563H158.803C158.34 65.1577 157.879 65.093 157.434 64.9641C156.624 64.7273 155.889 64.2877 155.297 63.6863C154.705 63.0848 154.278 62.3419 154.055 61.5281C153.968 61.2141 153.915 60.892 153.895 60.5672L153.75 59.5313L153.206 56.1938L152.7 53.1094C151.621 46.5238 148.236 40.5364 143.149 36.2171C138.062 31.8977 131.605 29.528 124.931 29.5313H40.7812C33.322 29.5313 26.1683 32.4944 20.8938 37.7689C15.6194 43.0433 12.6562 50.197 12.6562 57.6563V123.328C12.5021 123.296 12.345 123.28 12.1875 123.281C11.5659 123.281 10.9697 123.528 10.5302 123.967C10.0906 124.407 9.84375 125.003 9.84375 125.625V159.844C9.84375 160.465 10.0906 161.062 10.5302 161.501C10.9697 161.94 11.5659 162.188 12.1875 162.188C12.3659 162.189 12.5437 162.168 12.7171 162.127C13.178 169.256 16.3351 175.944 21.5474 180.831C26.7597 185.717 33.6365 188.437 40.7812 188.438H45.5437C46.0147 194.31 48.6802 199.79 53.0095 203.786C57.3389 207.782 63.0145 210.001 68.9062 210.001C74.798 210.001 80.4736 207.782 84.803 203.786C89.1323 199.79 91.7977 194.31 92.2687 188.438H148.669C149.138 194.254 151.76 199.686 156.022 203.672C160.284 207.658 165.88 209.91 171.715 209.988C177.55 210.067 183.204 207.966 187.572 204.097C191.94 200.227 194.707 194.867 195.333 189.066L219.905 189.628C222.38 189.685 224.778 188.76 226.574 187.055C228.369 185.351 229.418 183.005 229.491 180.53L230.156 158.156C230.775 136.629 225.043 115.397 213.675 97.1063ZM201.9 127.238L175.219 126.127C173.017 126.036 170.918 125.174 169.29 123.69C167.661 122.206 166.607 120.196 166.312 118.012L162.136 86.9719C161.966 85.7123 162.068 84.4308 162.434 83.2139C162.8 81.997 163.423 80.8725 164.26 79.9158C165.097 78.9595 166.129 78.1931 167.287 77.6686C168.444 77.1441 169.701 76.8736 170.972 76.875H174.253C176.885 76.8741 179.488 77.4145 181.902 78.4631C184.315 79.5113 186.488 81.045 188.283 82.9688L191.095 85.9828C200.167 95.7117 205.885 108.09 207.413 121.303C207.436 121.508 207.449 121.715 207.45 121.922C207.45 122.64 207.304 123.35 207.022 124.01C206.739 124.67 206.327 125.266 205.808 125.763C205.29 126.259 204.676 126.646 204.005 126.9C203.333 127.153 202.617 127.268 201.9 127.238Z"
                  fill="black"
                />
              </svg>
              Track Orders
            </li>
          )}

          <li
            className="profileCard__dropdownMenuItem flex-row"
            onClick={() => handleMovePage("connections")}
          >
            <svg
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M28.8981 29.0792C35.7604 29.0792 41.6199 30.1672 41.6199 34.5207C41.6199 38.8724 35.798 40 28.8981 40C22.0357 40 16.1762 38.9121 16.1762 34.5603C16.1762 30.2068 21.9981 29.0792 28.8981 29.0792ZM18.1312 26.4585C18.1706 26.4639 18.1903 26.4927 18.1939 26.5089C18.1992 26.5359 18.1885 26.5756 18.1384 26.6044C16.9242 27.2078 12.2377 29.8321 12.8268 35.3655C12.8519 35.6068 12.6621 35.8122 12.4239 35.778C11.2706 35.6122 8.30326 34.971 7.38278 32.9735C6.87241 31.9162 6.87241 30.6913 7.38278 29.634C7.9845 28.3461 9.43505 27.46 11.6431 27.0241C12.6872 26.7701 15.5059 26.4098 18.1312 26.4585ZM28.8981 8C33.5703 8 37.3166 11.7645 37.3166 16.4657C37.3166 21.1651 33.5703 24.9332 28.8981 24.9332C24.2258 24.9332 20.4795 21.1651 20.4795 16.4657C20.4795 11.7645 24.2258 8 28.8981 8ZM17.6719 9.41161C18.1625 9.41161 18.6317 9.46385 19.0902 9.55751C19.1511 9.57192 19.2191 9.60254 19.2549 9.65658C19.2961 9.72502 19.2657 9.81688 19.2227 9.87632C17.8671 11.7874 17.0863 14.1182 17.0863 16.6183C17.0863 19.0139 17.8008 21.2456 19.0544 23.1008C19.1833 23.2918 19.0687 23.5493 18.8413 23.589C18.5261 23.6448 18.2037 23.6736 17.8742 23.6826C14.5881 23.7691 11.6386 21.6419 10.8238 18.4393C9.61502 13.6823 13.159 9.41161 17.6719 9.41161Z"
                fill="black"
              />
            </svg>
            Connections
          </li>
          <li
            className="profileCard__dropdownMenuItem flex-row"
            onClick={showSetting}
          >
            <svg
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M25.4345 4C26.9469 4 28.3164 4.84 29.0726 6.08C29.4405 6.68 29.6858 7.42 29.6245 8.2C29.5836 8.8 29.7676 9.4 30.0946 9.96C31.137 11.66 33.4466 12.3 35.2452 11.34C37.2687 10.18 39.8236 10.88 40.9886 12.86L42.3581 15.22C43.5435 17.2 42.8895 19.74 40.8456 20.88C39.1082 21.9 38.4951 24.16 39.5375 25.88C39.8645 26.42 40.2324 26.88 40.8047 27.16C41.5201 27.54 42.0719 28.14 42.4603 28.74C43.2165 29.98 43.1552 31.5 42.4194 32.84L40.9886 35.24C40.2324 36.52 38.8221 37.32 37.3709 37.32C36.6555 37.32 35.8584 37.12 35.2044 36.72C34.6729 36.38 34.0598 36.26 33.4057 36.26C31.3822 36.26 29.6858 37.92 29.6245 39.9C29.6245 42.2 27.7441 44 25.3936 44H22.6138C20.2429 44 18.3625 42.2 18.3625 39.9C18.3216 37.92 16.6252 36.26 14.6017 36.26C13.9272 36.26 13.314 36.38 12.8031 36.72C12.149 37.12 11.3314 37.32 10.6365 37.32C9.16489 37.32 7.75459 36.52 6.99834 35.24L5.58804 32.84C4.83179 31.54 4.79091 29.98 5.54716 28.74C5.87419 28.14 6.48736 27.54 7.18229 27.16C7.75459 26.88 8.12249 26.42 8.46996 25.88C9.49192 24.16 8.87874 21.9 7.14141 20.88C5.11794 19.74 4.46389 17.2 5.62892 15.22L6.99834 12.86C8.18381 10.88 10.7183 10.18 12.7622 11.34C14.5404 12.3 16.85 11.66 17.8924 9.96C18.2194 9.4 18.4034 8.8 18.3625 8.2C18.3216 7.42 18.5465 6.68 18.9348 6.08C19.6911 4.84 21.0605 4.04 22.5525 4H25.4345ZM24.0242 18.36C20.8152 18.36 18.2194 20.88 18.2194 24.02C18.2194 27.16 20.8152 29.66 24.0242 29.66C27.2331 29.66 29.7676 27.16 29.7676 24.02C29.7676 20.88 27.2331 18.36 24.0242 18.36Z"
                fill="white"
              />
            </svg>
            Settings
          </li>
          <li className="profileCard__dropdownMenuItem flex-row">
            <svg
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22.9855 4C27.9506 4 32 7.98 32 12.88V22.46H19.7907C18.9157 22.46 18.2238 23.14 18.2238 24C18.2238 24.84 18.9157 25.54 19.7907 25.54H32V35.1C32 40 27.9506 44 22.9448 44H13.0349C8.04942 44 4 40.02 4 35.12V12.9C4 7.98 8.06977 4 13.0552 4H22.9855ZM37.0804 17.1004C37.6804 16.4804 38.6604 16.4804 39.2604 17.0804L45.1004 22.9004C45.4004 23.2004 45.5604 23.5804 45.5604 24.0004C45.5604 24.4004 45.4004 24.8004 45.1004 25.0804L39.2604 30.9004C38.9604 31.2004 38.5604 31.3604 38.1804 31.3604C37.7804 31.3604 37.3804 31.2004 37.0804 30.9004C36.4804 30.3004 36.4804 29.3204 37.0804 28.7204L40.2804 25.5404H32.0004V22.4604H40.2804L37.0804 19.2804C36.4804 18.6804 36.4804 17.7004 37.0804 17.1004Z"
                fill="white"
              />
            </svg>
            Logout
          </li>
          <li className="profileCard__dropdownMenuItem flex-row toggle">
            <div className="profileCard__dropdownToggle">
              <input
                type="checkbox"
                checked={darkMode}
                onChange={() => setDarkMode((darkMode) => !darkMode)}
              />
              <div
                className="profileCard__dropdownToggleIcon item-center rounded"
                onClick={() => setDarkMode((darkMode) => !darkMode)}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 29 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="4.24707"
                    y="4.45752"
                    width="20.5061"
                    height="20.5061"
                    fill="white"
                  />
                  <rect
                    y="14.7104"
                    width="20.5061"
                    height="20.5061"
                    transform="rotate(-45 0 14.7104)"
                    fill="white"
                  />
                  <circle cx="14.3973" cy="14.8128" r="8.09991" fill="black" />
                  <circle cx="14.3973" cy="14.8129" r="6.86954" fill="white" />
                </svg>
              </div>
            </div>
          </li>
        </ul>
      </div>
      {isSettingOpen && <SettingPopup onClick={showSetting} />}
    </>
  );
};

export default ProfilePage;
